import React from 'react';
import PropTypes from 'prop-types';
import ModelSelector from '../../PromptWizard/ModelSelector';

const StepModelConfig = ({ 
  config1, 
  setConfig1,
  config2,
  setConfig2,
  availableProviders
}) => {
  return (
    <div className="wizard-step">
      <div className="step-header">
        <h2 className="step-title">Select Models</h2>
        <p className="step-description">Choose two models to compare</p>
      </div>

      <div className="step-content space-y-6">
        {/* Models Side by Side */}
        <div className="form-section">
          <label className="form-label">Select Models to Compare</label>
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-4 items-start">
            {/* Model 1 */}
            <div className="flex flex-col gap-2">
              <span className="text-xs font-medium text-text-tertiary uppercase tracking-wider">Model 1</span>
              <ModelSelector
                model={config1.model}
                setModel={(model) => setConfig1({ ...config1, model })}
                llmConfig={config1}
                setLLMConfig={setConfig1}
                availableProviders={availableProviders}
              />
            </div>

            {/* VS Divider */}
            <div className="flex items-center justify-center pt-8">
              <div className="px-4 py-1.5 bg-bg-tertiary border-2 border-border-primary rounded-md">
                <span className="text-sm font-bold text-text-secondary uppercase tracking-wider">VS</span>
              </div>
            </div>

            {/* Model 2 */}
            <div className="flex flex-col gap-2">
              <span className="text-xs font-medium text-text-tertiary uppercase tracking-wider">Model 2</span>
              <ModelSelector
                model={config2.model}
                setModel={(model) => setConfig2({ ...config2, model })}
                llmConfig={config2}
                setLLMConfig={setConfig2}
                availableProviders={availableProviders}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

StepModelConfig.propTypes = {
  config1: PropTypes.shape({
    model: PropTypes.string.isRequired
  }).isRequired,
  setConfig1: PropTypes.func.isRequired,
  config2: PropTypes.shape({
    model: PropTypes.string.isRequired
  }).isRequired,
  setConfig2: PropTypes.func.isRequired,
  availableProviders: PropTypes.arrayOf(PropTypes.string)
};

export default StepModelConfig;

